/**
 * TanStack Query hooks for `default-campaign-url-vs-publisher-override`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	defaultCampaignUrlVsPublisherOverrideQueryKeys,
	type CreateDefaultCampaignUrlVsPublisherOverrideBody,
	type ListDefaultCampaignUrlVsPublisherOverrideResponse,
	type DefaultCampaignUrlVsPublisherOverrideRow,
} from "./api";

export function useDefaultCampaignUrlVsPublisherOverrideList(): UseQueryResult<ListDefaultCampaignUrlVsPublisherOverrideResponse, Error> {
	return useQuery({
		queryKey: defaultCampaignUrlVsPublisherOverrideQueryKeys.list(),
		queryFn: list,
	});
}

export function useDefaultCampaignUrlVsPublisherOverrideCreate(): UseMutationResult<DefaultCampaignUrlVsPublisherOverrideRow, Error, CreateDefaultCampaignUrlVsPublisherOverrideBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: defaultCampaignUrlVsPublisherOverrideQueryKeys.all });
		},
	});
}

export function useDefaultCampaignUrlVsPublisherOverrideDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: defaultCampaignUrlVsPublisherOverrideQueryKeys.all });
		},
	});
}
